import React, { useState, useEffect, Suspense } from "react";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import { FaSpinner } from "react-icons/fa";
import { ThemeProvider } from "./context/ThemeContext";
import { LangProvider } from "./context/LangContext"; 
import { App as CapacitorApp } from '@capacitor/app';
import { Network } from '@capacitor/network';
import Swal from 'sweetalert2';
import PublicProductView from './pages/PublicProductView';
import VisitingCard from './pages/VisitingCard';
import CustomerForgot from './customer/pages/CustomerForgot';
// सबसे ऊपर इम्पोर्ट सेक्शन में जोड़ें
import { PushNotifications } from '@capacitor/push-notifications';
import { LocalNotifications } from '@capacitor/local-notifications';

// ============================================================
// ⚙️ SYSTEM SETTINGS
// ============================================================
const CURRENT_VERSION = "v2.4"; // Version Same Rakhna hai

const isMobileApp = window.location.protocol === 'file:' || window.location.hostname === 'localhost';
axios.defaults.baseURL = isMobileApp ? 'https://billing.bhavyaaibot.com' : '';

// 🛡️ SECURITY GUARD (ORIGINAL - DO NOT TOUCH ADMIN LOGIC)
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers['x-auth-token'] = token;
    return config;
  },
  (error) => Promise.reject(error)
);

// 🚀 ANTI-LOOP FLAG: ताकि पॉपअप बार-बार फ्लैश न हो
let isLoggingOut = false;
let isPlanExpired = false; // 🚀 BHAVYA AI: Plan Expiry Flag

axios.interceptors.response.use(
  (response) => response,
  (error) => {
      // 🚀 BHAVYA AI: PHASE 3 - PLAN EXPIRED REDIRECT ENGINE (402 ERROR)
      if (error.response && error.response.status === 402 && error.response.data && error.response.data.code === 'PLAN_EXPIRED') {
          if (isPlanExpired) return Promise.reject(error); // अगर पॉपअप पहले से खुला है तो दोबारा मत खोलो
          isPlanExpired = true;

          if (!document.getElementById('bhavya-expired-popup')) {
              const overlay = document.createElement('div');
              overlay.id = 'bhavya-expired-popup';
              overlay.style.cssText = `
                  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
                  background: rgba(15, 23, 42, 0.85); backdrop-filter: blur(10px);
                  z-index: 999999; display: flex; align-items: center; justify-content: center;
                  opacity: 0; transition: opacity 0.4s ease; font-family: 'Segoe UI', sans-serif;
              `;

              overlay.innerHTML = `
                  <div style="background: linear-gradient(135deg, #1e293b, #0f172a); border: 1px solid rgba(245, 158, 11, 0.3); padding: 40px; border-radius: 24px; text-align: center; box-shadow: 0 25px 50px -12px rgba(245, 158, 11, 0.2); transform: translateY(20px); transition: transform 0.4s ease; max-width: 400px; width: 90%;">
                      <div style="width: 70px; height: 70px; background: rgba(245, 158, 11, 0.1); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; border: 1px solid rgba(245, 158, 11, 0.3);">
                          <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" style="color: #f59e0b; width: 35px; height: 35px;" xmlns="http://www.w3.org/2000/svg"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
                      </div>
                      <h2 style="color: #ffffff; font-size: 22px; font-weight: 800; margin: 0 0 12px; letter-spacing: 0.5px;">Plan Expired!</h2>
                      <p style="color: #94a3b8; font-size: 14px; line-height: 1.6; margin: 0; font-weight: 500;">Your Free Trial or Subscription has ended.<br/>Redirecting to Pricing page...</p>
                      <div style="margin-top: 30px; width: 100%; background: rgba(255,255,255,0.05); height: 6px; border-radius: 3px; overflow: hidden;">
                          <div id="bhavya-plan-progress" style="width: 0%; background: linear-gradient(90deg, #f59e0b, #fbbf24); height: 100%; transition: width 2.5s linear;"></div>
                      </div>
                  </div>
              `;

              document.body.appendChild(overlay);

              requestAnimationFrame(() => {
                  overlay.style.opacity = '1';
                  overlay.firstElementChild.style.transform = 'translateY(0)';
                  setTimeout(() => {
                      const bar = document.getElementById('bhavya-plan-progress');
                      if (bar) bar.style.width = '100%';
                  }, 50);
              });

              // 2.5 सेकंड बाद पॉपअप हटाओ और प्राइसिंग पेज पर भेज दो
              setTimeout(() => {
                  if(document.body.contains(overlay)) document.body.removeChild(overlay);
                  isPlanExpired = false;
                  window.location.href = '/#/pricing';
              }, 2500);
          }

          return Promise.reject(error);
      }

      // 👇 OLD LOGIC (SESSION EXPIRED 401/403)
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {


        const currentPath = window.location.hash;

        // 🚀 BHAVYA AI: PREMIUM GHOST SESSION KILLER (English + Anti-Loop)
        if (error.response.data && (error.response.data.code === 'FORCE_LOGOUT' || String(error.response.data.msg).includes('Session Expired'))) {
            
            // अगर लॉगआउट प्रोसेस चालू हो चुका है, तो बाकी के एरर्स को इग्नोर करो (Flashing रोकेगा)
            if (isLoggingOut) return Promise.reject(error);
            isLoggingOut = true; 

            // तुरंत टोकन उड़ाओ
            localStorage.removeItem('token');
            localStorage.removeItem('adminToken');
            
            if (!document.getElementById('bhavya-session-popup')) {
                const overlay = document.createElement('div');
                overlay.id = 'bhavya-session-popup';
                overlay.style.cssText = `
                    position: fixed; top: 0; left: 0; width: 100%; height: 100%;
                    background: rgba(15, 23, 42, 0.85); backdrop-filter: blur(10px);
                    z-index: 999999; display: flex; align-items: center; justify-content: center;
                    opacity: 0; transition: opacity 0.4s ease; font-family: 'Segoe UI', sans-serif;
                `;

                overlay.innerHTML = `
                    <div style="background: linear-gradient(135deg, #1e293b, #0f172a); border: 1px solid rgba(255,255,255,0.1); padding: 40px; border-radius: 24px; text-align: center; box-shadow: 0 25px 50px -12px rgba(0,0,0,0.5); transform: translateY(20px); transition: transform 0.4s ease; max-width: 400px; width: 90%;">
                        <div style="width: 70px; height: 70px; background: rgba(244, 63, 94, 0.1); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; border: 1px solid rgba(244, 63, 94, 0.2);">
                            <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" style="color: #f43f5e; width: 35px; height: 35px;" xmlns="http://www.w3.org/2000/svg"><path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path><line x1="12" y1="2" x2="12" y2="12"></line></svg>
                        </div>
                        <h2 style="color: #ffffff; font-size: 22px; font-weight: 800; margin: 0 0 12px; letter-spacing: 0.5px;">Session Expired!</h2>
                        <p style="color: #94a3b8; font-size: 14px; line-height: 1.6; margin: 0; font-weight: 500;">Your account was logged in from another device.<br/>For security reasons, you are being logged out...</p>
                        <div style="margin-top: 30px; width: 100%; background: rgba(255,255,255,0.05); height: 6px; border-radius: 3px; overflow: hidden;">
                            <div id="bhavya-progress" style="width: 0%; background: linear-gradient(90deg, #f43f5e, #fb7185); height: 100%; transition: width 2.5s linear;"></div>
                        </div>
                    </div>
                `;

                document.body.appendChild(overlay);

                requestAnimationFrame(() => {
                    overlay.style.opacity = '1';
                    overlay.firstElementChild.style.transform = 'translateY(0)';
                    setTimeout(() => { 
                        const bar = document.getElementById('bhavya-progress');
                        if (bar) bar.style.width = '100%'; 
                    }, 50);
                });

                setTimeout(() => {
                    // 🚀 HARD RELOAD: React की मेमोरी पूरी तरह खाली करके सीधा लॉगिन पर फेंक देगा (लूप का नामोनिशान मिट जाएगा)
                    window.location.replace('/#/login');
                    window.location.reload();
                }, 2500);
            }
            
            return Promise.reject(error);
        }

        // 🔥 ONLY NEW LOGIC: Agar Customer App hai to Admin Login pe mat jao
        if (currentPath.includes('#/store') || currentPath.includes('#/c')) {
            console.log("Customer Session Expired, redirecting to store...");
            localStorage.removeItem('customerToken');
            localStorage.removeItem('activeShopData');

            const pathParts = currentPath.split('/');
            const shopIdFromUrl = pathParts.find(p => p.length === 24);
            if(shopIdFromUrl) window.location.href = `/#/store/${shopIdFromUrl}`;
            else window.location.href = '/#/store';
            return Promise.reject(error);
        }

        // 👇 OLD LOGIC (TOTALLY UNCHANGED FOR ADMIN)
        if (!currentPath.includes('#/store') && !currentPath.includes('#/invoice/view')) {
            if (currentPath !== '#/login') {
                localStorage.removeItem('token');
                localStorage.removeItem('adminToken');
                window.location.href = "/#/login";
            }
        }
    }
    return Promise.reject(error);
  }
);

// ==========================================
// 🚀 MASTER LAZY LOADING (Same)
// ==========================================
const Layout = React.lazy(() => import("./layout/Layout"));
const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const Products = React.lazy(() => import("./pages/Products"));
const Parties = React.lazy(() => import("./pages/Parties"));
const NewInvoice = React.lazy(() => import("./pages/NewInvoice"));
const POSInvoice = React.lazy(() => import("./pages/POSInvoice"));
const Purchase = React.lazy(() => import("./pages/Purchase"));
const PurchaseOrder = React.lazy(() => import("./pages/PurchaseOrder"));
const Reports = React.lazy(() => import("./pages/Reports"));
const Settings = React.lazy(() => import("./pages/Settings"));
const BackupExport = React.lazy(() => import("./pages/BackupExport"));
const SaleList = React.lazy(() => import("./pages/SaleList"));
const Utilities = React.lazy(() => import("./pages/Utilities"));
const Subscription = React.lazy(() => import ("./pages/Subscription"));
const BarcodeGenerator = React.lazy(() => import("./pages/BarcodeGenerator"));
const PriceListManager = React.lazy(() => import("./pages/PriceListManager"));
const Finance  = React.lazy(() => import("./pages/Finance"));
const Expenses  = React.lazy(() => import("./pages/Expenses"));
const DeliveryChallan  = React.lazy(() => import("./pages/DeliveryChallan"));
const CreditNote  = React.lazy(() => import("./pages/CreditNote"));
const GSTReport = React.lazy(() => import('./pages/GSTReport'));

const StockSummary = React.lazy(() => import('./pages/inventory/StockSummary'));
const StockTransfer = React.lazy(() => import('./pages/inventory/StockTransfer'));
const StockAdjustment = React.lazy(() => import('./pages/inventory/StockAdjustment'));
const OpeningStock = React.lazy(() => import('./pages/inventory/OpeningStock'));
const RoleManager = React.lazy(() => import('./pages/settings/RoleManager'));
const AuditTrail = React.lazy(() => import('./pages/settings/AuditTrail'));
const CostCenters = React.lazy(() => import('./pages/masters/CostCenters'));
const FinancialYear = React.lazy(() => import('./pages/settings/FinancialYear'));
const GodownManager = React.lazy(() => import('./pages/GodownManager'));

// 🛒 CUSTOMER APP LAZY IMPORTS
const StoreEntry = React.lazy(() => import("./customer/StoreEntry"));
const CustomerLogin = React.lazy(() => import("./customer/pages/CustomerLogin"));
const CustomerLayout = React.lazy(() => import("./customer/CustomerLayout"));
const AppLock = React.lazy(() => import("./customer/components/AppLock"));
const CustomerHome = React.lazy(() => import("./customer/pages/CustomerHome"));
const CustomerCart = React.lazy(() => import("./customer/pages/CustomerCart"));
const CustomerProfile = React.lazy(() => import("./customer/pages/CustomerProfile"));
const CustomerOrders = React.lazy(() => import("./customer/pages/CustomerOrders"));
const CustomerInbox = React.lazy(() => import("./customer/pages/CustomerInbox"));
const CustomerRegister = React.lazy(() => import("./customer/pages/CustomerRegister"));
const OnlineOrders = React.lazy(() => import("./pages/OnlineOrders"));
const AppManager = React.lazy(() => import("./pages/AppManager"));
const CustomerProducts = React.lazy(() => import("./customer/pages/CustomerProducts"));
const CustomerStatement = React.lazy(() => import("./customer/pages/CustomerStatement"));
const CustomerReviews = React.lazy(() => import("./customer/pages/CustomerReviews"));
const Rewards = React.lazy(() => import("./customer/pages/Rewards"));
const DeliveryBooking = React.lazy(() => import("./customer/pages/DeliveryBooking"));
const DriverDeliveries = React.lazy(() => import("./customer/pages/DriverDeliveries"));
const InvoiceMaster = React.lazy(() => import("./components/InvoiceTemplates/InvoiceMaster"));

// Other Imports...
const Login = React.lazy(() => import("./pages/Login"));
const SignUp = React.lazy(() => import("./pages/SignUp"));
const ResetPassword = React.lazy(() => import("./pages/ResetPassword"));
const AppDownload = React.lazy(() => import("./pages/AppDownload"));
const LedgerList = React.lazy(() => import('./pages/masters/LedgerList'));
const VoucherEntry = React.lazy(() => import("./pages/accounts/VoucherEntry"));
const Appearance = React.lazy(() => import("./pages/Appearance"));
const PartyStatement = React.lazy(() => import("./pages/PartyStatement"));

const WhatsAppSettings = React.lazy(() => import('./pages/WhatsAppSettings'));
const Catalogue = React.lazy(() => import('./pages/Catalogue'));
const AdminMedia = React.lazy(() => import('./pages/AdminMedia'));
const Terms = React.lazy(() => import('./pages/Terms'));
const Privacy = React.lazy(() => import('./pages/Privacy'));
const Contact = React.lazy(() => import('./pages/Contact'));
const Refund = React.lazy(() => import('./pages/Refund'));
const Shipping = React.lazy(() => import('./pages/Shipping'));
const About = React.lazy(() => import('./pages/About'));
const Disclaimer = React.lazy(() => import('./pages/Disclaimer'));
const Cookie = React.lazy(() => import('./pages/Cookie'));
const TrialBalance = React.lazy(() => import('./pages/reports/TrialBalance'));
const ProfitLoss = React.lazy(() => import('./pages/reports/ProfitLoss'));
const Help = React.lazy(() => import('./pages/Help'));
const Groups = React.lazy(() => import('./pages/masters/Groups'));
const BalanceSheet = React.lazy(() => import('./pages/reports/BalanceSheet'));
const AdminLogin = React.lazy(() => import('./pages/admin/AdminLogin'));
const CEODashboard = React.lazy(() => import('./pages/admin/CEODashboard'));
const SupportLoginHandler = React.lazy(() => import('./pages/SupportLoginHandler'));
const Pricing = React.lazy(() => import('./pages/Pricing'));
const StaffManagement = React.lazy(() => import('./pages/StaffManagement'));
const PublicInvoice = React.lazy(() =>  import('./pages/PublicInvoice'));

const Loading = () => (
  <div className="flex justify-center items-center h-screen bg-slate-900">
    <div className="text-center">
        <FaSpinner className="animate-spin text-4xl text-blue-500 mx-auto mb-4" />
        <p className="text-blue-200 text-sm font-bold animate-pulse">Bhavya AI™ Loading...</p>
    </div>
  </div>
);

// 📡 नेटवर्क ट्रैक करने के लिए एक बाहरी वेरिएबल (ताकि फालतू पॉप-अप न आए)
let wasOfflineTracker = false;

function App() {
  const [logged, setLogged] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isOffline, setIsOffline] = useState(false); // 🚀 LIVE NETWORK STATE

// 🚀 THE REAL FIX: कस्टमर के लिए स्मार्ट बैकग्राउंड टोकन सिंक (बिना Admin स्टेट के)
  useEffect(() => {
      const syncChecker = setInterval(async () => {
          const fcmToken = localStorage.getItem('fcm_token');
          // कस्टमर और एडमिन दोनों का टोकन चेक करेगा
          const custToken = localStorage.getItem('customerToken') || localStorage.getItem('token');
          const isSynced = localStorage.getItem('fcm_synced_value');

          // अगर FCM टोकन बन गया है, यूज़र लॉगिन है, और अभी तक सर्वर पर नहीं भेजा गया है
          if (fcmToken && custToken && fcmToken !== isSynced) {
              try {
                  await axios.post('/api/customer/update-fcm-token', 
                      { fcmToken: fcmToken }, 
                      { headers: { 'x-auth-token': custToken } }
                  );
                  // एक बार सक्सेस हो गया, तो इसे सेव कर लो ताकि बार-बार API कॉल न हो
                  localStorage.setItem('fcm_synced_value', fcmToken); 
                  console.log("✅ Token successfully synced to Server!");
              } catch (err) {
                  // अगर कोई एरर आए, तो चुपचाप अगली बार ट्राई करेगा
              }
          }
      }, 3000); // यह हर 3 सेकंड में बैकग्राउंड में बिना ऐप अटकाए चेक करेगा

      return () => clearInterval(syncChecker);
  }, []);

useEffect(() => {
    // 📡 1. LIVE NETWORK LISTENER (FIXED: Switching Network Bug)
    const setupNetwork = async () => {
        if (!window.Capacitor || !window.Capacitor.isNativePlatform()) return;

        const status = await Network.getStatus();
        setIsOffline(!status.connected);
        wasOfflineTracker = !status.connected; // पहली बार चेक किया

        Network.addListener('networkStatusChange', status => {
            setIsOffline(!status.connected);
            
            // 🚀 FIX: अगर सच में पहले नेट बंद था, और अब चालू हुआ है, तभी पॉप-अप दिखाओ!
            if (status.connected && wasOfflineTracker) {
                Swal.fire({ icon: 'success', title: 'Internet Restored ✅', toast: true, position: 'top-end', timer: 3000, showConfirmButton: false, background: '#1e293b', color: '#fff' });
                wasOfflineTracker = false; // अब वापस ऑनलाइन है
            } else if (!status.connected) {
                wasOfflineTracker = true; // अब नेट चला गया
            }
        });
    };
    setupNetwork();

   // 🚀 2. AUTO APP UPDATE CHECKER (DYNAMIC JSON)
    const checkAppUpdate = async () => {
        if (window.Capacitor && window.Capacitor.isNativePlatform()) {
            try {
                // 1. सर्वर से लाइव वर्ज़न चेक करें (URL के आगे time इसलिए लगाया है ताकि कैश न हो)
                const { data } = await axios.get(`https://billing.bhavyaaibot.com/app/app-version.json?t=${new Date().getTime()}`);
                const latestVersion = data.latestAndroidVersion;

                const info = await CapacitorApp.getInfo();
                
                // 🚀 HYBRID MATH FIX: टेक्स्ट को असली नंबर में बदलकर चेक करें (ताकि कोई कंफ्यूजन न हो)
                const current = parseFloat(info.version);
                const latest = parseFloat(latestVersion);

                if (current >= latest) {
                    localStorage.removeItem('updateSnoozeTime'); 
                    return; 
                }

// अगर सच में नया वर्ज़न है (Snooze हटा दिया गया है, ताकि कस्टमर को अपडेट करना ही पड़े)
                if (current < latest) {
                    setTimeout(async () => {
                        // 🔔 1. मोबाइल को हिलाओ (वाइब्रेशन)
                        if (navigator.vibrate) navigator.vibrate([500, 200, 500]);

                        // 🚀 2. THE MASTER FIX: असली एंड्रॉइड बैनर (बाहर से फ़ोर्स करने के लिए)
                        if (window.Capacitor && window.Capacitor.isNativePlatform()) {
                            try {
                                await LocalNotifications.schedule({
                                    notifications: [{
                                        title: '🔄 Mandatory App Update!',
                                        body: `Bhavya AI का नया वर्ज़न (v${latestVersion}) आ गया है। ऐप को चलाने के लिए अभी अपडेट करें!`,
                                        id: 888, // 👈 फिक्स ID: ताकि बार-बार एक ही नोटिफिकेशन अपडेट हो, कस्टमर का फोन हैंग न हो
                                        schedule: { at: new Date(Date.now() + 1000) }, // 1 सेकंड में गिरेगा
                                        channelId: 'bhavya_alerts' // 👈 आपका वही पावरफुल चैनल (घंटी बजेगी)
                                    }]
                                });
                            } catch (localErr) { console.error("Local Push Error:", localErr); }
                        }

                        // 🛑 3. ऐप के अंदर का ज़िद्दी पॉप-अप (जो बाहर क्लिक करने पर भी बंद नहीं होगा)
                        Swal.fire({
                            icon: 'warning',
                            title: '🔄 Mandatory Update!',
                            text: `Bhavya AI v${latestVersion} is here! Update now for new features and better speed.`,
                            showCancelButton: false, 
                            confirmButtonText: 'UPDATE NOW 🚀',
                            allowOutsideClick: false, 
                            allowEscapeKey: false,
                            confirmButtonColor: '#10b981',
                            background: '#0f172a',
                            color: '#ffffff',
                            backdrop: `rgba(0,0,0,0.85)`
                        }).then((result) => {
                            if (result.isConfirmed) {
                                // प्ले स्टोर पर भेजो
                                window.open('https://play.google.com/store/apps/details?id=com.bhavya.customer.v2', '_system');
                                // 🚀 लूप: अगर कस्टमर बिना अपडेट किये वापस ऐप में आ गया, तो 3 सेकंड बाद फिर से बैनर और पॉप-अप मारो!
                                setTimeout(checkAppUpdate, 3000);
                            }
                        });
                    }, 2000);
                }
            } catch (error) {
                console.error("Auto-Update Check Failed:", error);
            }
        }
    };
    checkAppUpdate();
// 🚀 SUPERFAST SILENT RESUME: बिना किसी API कॉल के ऐप तुरंत चालू होगा
    CapacitorApp.addListener('appStateChange', ({ isActive }) => {
        if (isActive) {
            setLoading(false); // बस लोडिंग हटाओ, कोई फालतू API कॉल नहीं
        }
    });

// 🚀 PUSH NOTIFICATION HANDLER (इसे useEffect के अंदर ही रखें)
    const initPush = async () => {
        if (!window.Capacitor || !window.Capacitor.isNativePlatform()) return;

        // 1️⃣ सबसे पहले चैनल बनाओ (बिना किसी शर्त के!)
        // इससे यह पक्का होगा कि मोबाइल सेटिंग्स में 'Bhavya Alerts' हमेशा दिखेगा
        try {
            if (window.Capacitor.getPlatform() === 'android') {
                await PushNotifications.createChannel({
                    id: 'bhavya_alerts',
                    name: 'Bhavya Alerts',
                    description: 'Important app notifications',
                    importance: 5, // 5 का मतलब मैक्सिमम प्रायोरिटी (बैनर गिरेगा)
                    visibility: 1
                });
                console.log("🟢 Notification Channel Created Successfully!");
            }
        } catch (channelErr) {
            console.error("Channel Creation Error:", channelErr);
        }

        // 2️⃣ अब कान लगाओ (Listeners) ताकि टोकन तुरंत पकड़ा जाए
        PushNotifications.addListener('registration', async (token) => {
            console.log('📱 Device FCM Token Generated:', token.value);
            localStorage.setItem('fcm_token', token.value);

            try {
                const custToken = localStorage.getItem('customerToken') || localStorage.getItem('token');
                if (custToken) {
                    await axios.post('/api/customer/update-fcm-token', 
                        { fcmToken: token.value },
                        { headers: { 'x-auth-token': custToken } }
                    );
                    localStorage.setItem('fcm_synced_value', token.value);
                    console.log("✅ Token successfully synced to Server!");
                }
            } catch (err) {
                console.error("Token Sync Error:", err);
            }
        });

        PushNotifications.addListener('pushNotificationReceived', (notification) => {
            Swal.fire({
                icon: 'info', title: notification.title, text: notification.body, toast: true, position: 'top', showConfirmButton: false, timer: 5000
            });
        });

        // 3️⃣ अब आख़िर में परमिशन चेक करो और मांगो
        try {
            let permStatus = await PushNotifications.checkPermissions();
            if (permStatus.receive === 'prompt') {
                permStatus = await PushNotifications.requestPermissions();
            }
            
            // 4️⃣ सबसे लास्ट में डिवाइस को रजिस्टर करो
            await PushNotifications.register();
        } catch (permErr) {
            console.error("Permission/Register Error:", permErr);
        }
    };
    initPush();

    const storedVersion = localStorage.getItem("appVersion");

    if (storedVersion !== CURRENT_VERSION) {
      console.log("🆕 Update Found! Clearing everything...");
      localStorage.clear();
      localStorage.setItem("appVersion", CURRENT_VERSION);
      setLogged(false);
      setLoading(false);
      window.location.reload();
      return;
    }

    const token = localStorage.getItem("token");
    if (token) {
      axios.defaults.headers.common['x-auth-token'] = token;
      setLogged(true);
    } else {
      setLogged(false);
    }
    
    // 🚀 SUPERFAST SILENT RESUME: बिना किसी API कॉल के ऐप तुरंत चालू होगा
    if (window.Capacitor && window.Capacitor.isNativePlatform()) {
        CapacitorApp.addListener('appStateChange', ({ isActive }) => {
            if (isActive) {
                setLoading(false); 
            }
        });
    }

    setLoading(false);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    localStorage.setItem("appVersion", CURRENT_VERSION);
    setLogged(false);
  };

  if (loading) return <Loading />;

  return (
    <>
      {isOffline && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(2, 6, 23, 0.95)', backdropFilter: 'blur(10px)', zIndex: 9999999, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: 'white', fontFamily: 'sans-serif' }}>
              <div style={{ width: '80px', height: '80px', background: 'rgba(239, 68, 68, 0.1)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px', border: '1px solid rgba(239, 68, 68, 0.3)' }}>
                  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#ef4444', width: '40px', height: '40px' }}><path d="M10.706 10.706l2.588 2.588M16 16l-3.294-3.294M3 3l18 18M18.364 5.636a9 9 0 00-12.728 0M21 9a11.95 11.95 0 00-2.828-2.828"></path></svg>
              </div>
              <h1 style={{ fontSize: '24px', fontWeight: '900', marginBottom: '10px' }}>Connection Lost</h1>
              <p style={{ color: '#94a3b8', fontSize: '14px', textAlign: 'center', maxWidth: '80%' }}>Please check your network. Bhavya AI will auto-connect when the internet is back.</p>
              <div style={{ marginTop: '30px' }} className="animate-pulse">
                  <div className="w-10 h-10 border-4 border-slate-700 border-t-rose-500 rounded-full animate-spin"></div>
              </div>
          </div>
      )}

      <HashRouter>
        <LangProvider>
        <ThemeProvider>
          <Suspense fallback={<Loading />}>
            <Routes>

              <Route path="/reset-password/:token" element={<ResetPassword />} />

              {/* ========================================== */}
              {/* 🛒 CUSTOMER APP ROUTES (TOP PRIORITY) */}
              {/* ========================================== */}
             <Route path="/store/:shopId" element={<StoreEntry />} />
             <Route path="/store-entry" element={<StoreEntry />} />
              
              {/* Customer Auth Flows */}
              <Route path="/c/login" element={<CustomerLogin />} />
              <Route path="/c/register" element={<CustomerRegister />} />
              <Route path="/c/forgot" element={<CustomerForgot />} />

              {/* Protected Customer Dashboard (🔒 Secured with AppLock) */}
              <Route path="/c" element={
                  <AppLock>
                      <CustomerLayout />
                  </AppLock>
              }>
                <Route path="home" element={<CustomerHome />} />
               <Route path="book-delivery" element={<DeliveryBooking />} />
                <Route path="deliveries" element={<DriverDeliveries />} />
                <Route path="products" element={<CustomerProducts />} />
                <Route path="statement" element={<CustomerStatement />} />
                <Route path="reviews" element={<CustomerReviews />} />
                <Route path="cart" element={<CustomerCart />} />
                <Route path="profile" element={<CustomerProfile />} />
                <Route path="orders" element={<CustomerOrders />} />
                <Route path="rewards" element={<Rewards />} />

                {/* 🚀 NEW: Customer Inbox (Live Chat) Route */}
                <Route path="inquiries" element={<CustomerInbox />} />

                </Route>

              {/* ========================================== */}
              {/* 🔒 ADMIN/SOFTWARE ROUTES (ORIGINAL) */}
              {/* ========================================== */}
              
              {/* Public Routes */}
              <Route path="/login" element={!logged ? <Login setLogged={setLogged} /> : <Navigate to="/" />} />
              <Route path="/signup" element={!logged ? <SignUp setLogged={setLogged} /> : <Navigate to="/" />} />
              <Route path="/p/:id" element={<PublicProductView />} />
              <Route path="/invoice/view/:id" element={<PublicInvoice />} />
              <Route path="/download" element={<AppDownload />} />
               {/* Legal Routes */}
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/refund" element={<Refund />} />
              <Route path="/shipping" element={<Shipping />} />
              <Route path="/about" element={<About />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/cookie" element={<Cookie />} />
              <Route path="/pricing" element={<Pricing />} />

              <Route path="/support-access" element={<SupportLoginHandler />} />

              <Route path="/admin-login" element={<AdminLogin />} />
              <Route path="/owner-secret-control" element={localStorage.getItem('adminToken') ? <CEODashboard /> : <Navigate to="/admin-login" />} />
              <Route path="/admin-media" element={<AdminMedia />} />

              {/* Protected Admin Routes */}
              {logged ? (
                <Route
                  path="/*"
                  element={
                    <Layout logout={handleLogout}>
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/parties" element={<Parties />} />
                        <Route path="/invoice" element={<NewInvoice />} />
                        <Route path="/pos" element={<POSInvoice />} />
                        <Route path="/masters/ledgers" element={<LedgerList />} />
                        <Route path="/vouchers/receipt" element={<VoucherEntry type="Receipt" />} />
                        <Route path="/vouchers/payment" element={<VoucherEntry type="Payment" />} />
                        <Route path="/vouchers/journal" element={<VoucherEntry type="Journal" />} />
                        <Route path="/vouchers/contra" element={<VoucherEntry type="Contra" />} />
                        <Route path="/reports/trial-balance" element={<TrialBalance />} />
                        <Route path="/reports/profit-loss" element={<ProfitLoss />} />
                        <Route path="/reports/balance-sheet" element={<BalanceSheet />} />
                        <Route path="/reports/gst" element={<GSTReport />} />
                        <Route path="/help" element={<Help />} />
                        <Route path="/masters/groups" element={<Groups />} />
                        <Route path="/sales-history" element={<SaleList />} />
                        <Route path="/purchase" element={<Purchase />} />
                        <Route path="/purchase-order" element={<PurchaseOrder />} />
                        <Route path="/reports" element={<Reports />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/backup" element={<BackupExport />} />
                        <Route path="/utilities" element={<Utilities />} />
                        
                        <Route path="/appearance" element={<Appearance />} />
                        <Route path="/whatsapp-config" element={<WhatsAppSettings />} />
                        <Route path="/catalogue" element={<Catalogue />} />
                        <Route path="/tools/barcodes" element={<BarcodeGenerator />} />
                        <Route path="/party-statement" element={<PartyStatement />} />
                        <Route path="/reports/party-statement/:id" element={<PartyStatement />} />
                        <Route path="/visiting-card" element={<VisitingCard />} />
                        <Route path="/tools/price-lists" element={<PriceListManager />} />
                        <Route path="/online-orders" element={<OnlineOrders />} />
                        <Route path="/app-manager" element={<AppManager />} />
                        <Route path="/subscription" element={<Subscription />} />
                        {/* 🖨️ THE INVOICE STUDIO ROUTE */}
                        <Route path="/invoice-studio" element={<InvoiceMaster />} />
                        <Route path="/invoice-studio/:id" element={<InvoiceMaster />} />

                         {/* 👇 ====== 🔥 NEW ERP INVENTORY ROUTES ====== 👇 */}
                        <Route path="/finance" element={<Finance />} />
                        <Route path="/expenses" element={<Expenses />} />
                       <Route path="/credit-note" element={<CreditNote />} />
                        <Route path="/delivery-challan" element={<DeliveryChallan />} />
                        <Route path="/inventory/summary" element={<StockSummary />} />
                        <Route path="/inventory/transfer" element={<StockTransfer />} />
                        <Route path="/inventory/adjustment" element={<StockAdjustment />} />
                         <Route path="/godowns" element={<GodownManager />} />
                        <Route path="/inventory/opening" element={<OpeningStock />} />
                        <Route path="/settings/audit" element={<AuditTrail />} />
                        <Route path="/masters/cost-centers" element={<CostCenters />} />
                        <Route path="/settings/year-close" element={<FinancialYear />} />
                        <Route path="/settings/roles" element={<RoleManager />} />
                        <Route path="/staff" element={<StaffManagement />} />
                         {/* 👆 ========================================= 👆 */}
                        <Route path="*" element={<Navigate to="/" />} />
                      </Routes>
                    </Layout>
                  }
                />
              ) : (
                <Route path="*" element={<Navigate to="/login" />} />
              )}

            </Routes>
          </Suspense>
        </ThemeProvider>
      </LangProvider>
    </HashRouter>
   </>
  );
}

export default App;